export default "__VITE_ASSET__BD73q$94__"